/**
 * @generated SignedSource<<f67030358c9331971aacf807779b565b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeletePersonInput = {
  id: string;
  clientId?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type deletePersonMutation$variables = {
  input: DeletePersonInput;
};
export type deletePersonMutation$data = {
  readonly deletePerson: {
    readonly deletedPersonId: string | null;
    readonly errors: ReadonlyArray<string | null> | null;
  } | null;
};
export type deletePersonMutation = {
  variables: deletePersonMutation$variables;
  response: deletePersonMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeletePersonPayload",
    "kind": "LinkedField",
    "name": "deletePerson",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedPersonId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errors",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deletePersonMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deletePersonMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "ba297f4178e99d9fade194fecf00bf64",
    "id": null,
    "metadata": {},
    "name": "deletePersonMutation",
    "operationKind": "mutation",
    "text": "mutation deletePersonMutation(\n  $input: DeletePersonInput!\n) {\n  deletePerson(input: $input) {\n    deletedPersonId\n    errors\n  }\n}\n"
  }
};
})();

(node as any).hash = "1ab5f9c0f989c5a55384cef0bf24002f";

export default node;
